const descriptions = [
  'Разбираем цель, сроки, документы, груз или участок.',
  'Собираем понятный маршрут действий и фиксируем приоритеты.',
  'Берем на себя подготовку, проверку и координацию.',
  'Доводим задачу до результата и остаемся на связи.',
];

function ProcessSection({ checkpoints }) {
  return (
    <section className="section process-section reveal" id="process">
      <div className="section-head">
        <span className="section-kicker">Как работаем</span>
        <h2>Премиальный порядок вместо хаоса</h2>
        <p>
          Важное отличие Chinatao: клиент видит не просто обещание, а понятную
          последовательность действий и ответственного человека на каждом этапе.
        </p>
      </div>

      <div className="process-grid">
        {checkpoints.map((item, index) => (
          <div className="process-step" key={item}>
            <span>{String(index + 1).padStart(2, '0')}</span>
            <h3>{item}</h3>
            <p>{descriptions[index]}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ProcessSection;
